import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";
const COLORS = {
  text: "#293142",
  muted: "#767c8f",
  label: "#9197a6",
  border: "#e6e9ef",
  brand: "#ef4f5f",
};



export const StatusBadge = styled.span`
  border-radius: 8px;
  padding: 8px;
  background: #fff1e6;
  color: #e86c37;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
`;

export const SummaryText = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
`;

export const SummaryLabel = styled.span`
  color: ${COLORS.label};
  font-size: 16px;
  line-height: 22px;
`;

export const MapLink = styled.a`
  color: ${COLORS.brand};
  font-family: ${fontFamilies.regular};
  font-size: 14px;
  line-height: 20px;
  text-decoration: underline dotted;
  white-space: nowrap;
`;

export const ProductsCard = styled.div`
  overflow: hidden;
  border: 1px solid ${COLORS.border};
  border-radius: 16px;
  background: #ffffff;
`;

export const ProductsTitle = styled.h2`
  margin: 0;
  border-bottom: 1px solid ${COLORS.border};
  padding: 24px 24px 20px;
  background: #f8f9fc;
  color: ${COLORS.text};
  font-family: ${fontFamilies.semiBold};
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;

export const ProductImage = styled.img`
  width: 40px;
  height: 40px;
  border: 0.5px solid ${COLORS.border};
  border-radius: 4px;
  object-fit: cover;
`;

export const CellText = styled.span`
  color: ${COLORS.text};
  font-size: 14px;
  line-height: 20px;
`;

export const GenerateQrButton = styled.button`
  border: 1px solid ${COLORS.brand};
  border-radius: 6px;
  padding: 8px 14px;
  background: #ffffff;
  color: ${COLORS.brand};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

export const StateMessage = styled.div`
  padding: 64px 0;
  color: ${COLORS.muted};
  text-align: center;
`;

export const DisputeSuggestionText = styled.span`
  display: block;
  color: var(--color-base-orange-500, rgba(232, 108, 55, 1));
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
`;
